

import { useEffect } from "react";
import { useAccountStore } from "@/store/account-store";
import { useRosterStore } from "@/store/roster-store";

export function FirebaseStoreInitializer({ children }: { children: React.ReactNode }) {
  const initAccountListener = useAccountStore((state) => state.initListener);
  const initRosterListener = useRosterStore((state) => state.initListener);

  useEffect(() => {
    const unsubAccount = initAccountListener();
    const unsubRoster = initRosterListener();

    return () => {
      unsubAccount();
      unsubRoster();
    };
  }, [initAccountListener, initRosterListener]);

  return <>{children}</>;
}
